import BuilderSection from './BuilderSection';
import BuilderColumn from './BuilderColumn';
import Subscription from './Subscription';
import contactForm from './contactForm';
import CounterDown from './CounterDown';
import BuilderRow from './BuilderRow';
import Accordion from './Accordion';
import ButtonComp from './Button';
import IconText from './IconText';
import Iframe from './Iframe';
import Video from './Video';
import Links from './Links';
import Title from './Title';
import Code from './Code';
import Text from './Text';
import Line from './Line';
import Icon from './Icon';
import Img from './Img';
import Nav from './Nav';

/**
 * All the required components to render the view
 */
export default {
    subscription: Subscription,
    counterdown: CounterDown,
    section: BuilderSection,
    column: BuilderColumn,
    button: ButtonComp,
    accordion: Accordion,
    iconText: IconText,
    row: BuilderRow,
    iframe: Iframe,
    video: Video,
    contactForm,
    links: Links,
    image: Img,
    code: Code,
    title: Title,
    text: Text,
    line: Line,
    icon: Icon,
    nav: Nav,
};
